import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.formId = null;
        this.interval = null;

        this.interval = setInterval(() => {
            if (this.el.querySelector('form').getAttribute('data-form-id')) {
                this.formId = this.el.querySelector('form').getAttribute('data-form-id');
                clearInterval(this.interval);
            }
        }, 1000);

        window.addEventListener('message', (event) => {
            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
                if (event.data.id === this.formId) {
                    this.el.classList.add('-sent');
                }
            }
        });
    }
}
